import styles from './SliderArrows.module.scss';
import cn from 'classnames';

type SliderArrowsProps = {
  onPrevClick: () => void;
  onNextClick: () => void;
  arrowClassName?: string;
  variant?: 'dark' | 'light';
};

export function SliderArrows({
  onPrevClick,
  onNextClick,
  arrowClassName,
  variant = 'dark',
}: SliderArrowsProps) {
  return (
    <div className={styles.arrows}>
      {variant === 'light' && (
        <>
          <img
            src="/svg/arrow-white.svg"
            alt="arrow-left"
            className={cn(styles.left, styles.rotated, arrowClassName)}
            onClick={onPrevClick}
          />
          <img
            src="/svg/arrow-white.svg"
            alt="arrow-right"
            className={cn(styles.right, styles.rotated, arrowClassName)}
            onClick={onNextClick}
          />
        </>
      )}
      {variant === 'dark' && (
        <>
          <img
            src="/svg/arrow-gray.svg"
            alt="arrow-left"
            className={cn(styles.left, arrowClassName)}
            onClick={onPrevClick}
          />
          <img
            src="/svg/arrow-gray.svg"
            alt="arrow-right"
            className={cn(styles.right, arrowClassName)}
            onClick={onNextClick}
          />
        </>
      )}
    </div>
  );
}
